import { BaseModel } from '@/api/base-model'
import { OrderCountAPI } from '@/api/backend-client'
import { v4 } from 'uuid'

export class OrderCount extends BaseModel<OrderCount> {
    protected collectionName = OrderCountAPI.collectionName

    constructor(
        public pendingOrders: number,
        public successfulOrders: number,
        public unsuccessfulOrders: number,
    ) {
        super(v4())

        this.pendingOrders = pendingOrders
        this.successfulOrders = successfulOrders
        this.unsuccessfulOrders = unsuccessfulOrders
    }

    static fromData(data: any): OrderCount {
        if (data === null || typeof data === 'string' || data instanceof OrderCount) {
            return data
        }

        return new OrderCount(
            data.pendingOrders,
            data.successfulOrders,
            data.unsuccessfulOrders,
        )
    }
}
